import L from 'leaflet';
import ReactDOM from 'react-dom';
import {PopupBehavior, map, SetLastInsertedId, SetLastOpenedPopup, GetUserName, GetUserId, GetUserPermissions, isMobileVersion, 
  loadedMarkers, GetSelectedVoltageCodes, OpenSideBar, DeleteObjectWithConfirm, StartCurveLine, SetCurrentBottomSheet, HighlightMarker, ClearMarkerHighlight } from './Main.js'
import {PolePopupSetup, UnLoadAllPoles} from './PoleManager.js'
import {DecorativePopupSetup} from './SergekManager';
import {/*LinePopupBehavior,*/ LinePopupSetup, linesData, UnLoadAllLines, updatePolylineByFromId, updatePolylineByToId, AddLine } from './lines.js'
import {DrawMainMarker, DrawPoleMarker, ClearPoleMarkersArray, SetLastInsertedMarker, DrawDecorativeMarker, SetDraggable} from './MarkerManager.js'
import { PPBottomSheet } from '../react-components/mobile/PPBottomSheet';
import { EditPPSheet } from '../react-components/mobile/EditPPSheet';
import { AddPSSheet } from '../react-components/mobile/AddPSSheet';
import { AddLineSheet } from '../react-components/mobile/AddLineSheet';
import { FidersSheet } from '../react-components/mobile/FidersSheet';

export var linkedtpArray = [];

var activeFiderLineId = null;
var fiderBoundsSet = false; 

export const linkedtpData = {
  linkedtpArray: []
};

var lastLinkedObj = '';

export var movingPPArray = [];

var showingAllLinkedObjects = [];
var showingLinkedObjects = [];

var lastMyDiv = null;

export function PushShowingLinkedObjects(linkedtp) {
  showingLinkedObjects.push(linkedtp);
  showingAllLinkedObjects.push(linkedtp);
}

export function ClearPPModuleState() {
  linkedtpArray.length = 0;
  linkedtpData.linkedtpArray.length = 0;
  movingPPArray.length = 0;
  showingAllLinkedObjects = [];
  showingLinkedObjects = [];
  activeFiderLineId = null;
  fiderBoundsSet = false;
  lastLinkedObj = '';
}

export function HideFider() {
  if (!activeFiderLineId) return;
  
  UnLoadAllPoles();
  UnLoadAllLines();
  ClearShowingLinkedObjects();
  ClearShowingAllLinkedObjects();
  activeFiderLineId = null;
  fiderBoundsSet = false;
}

export async function FillingShowingLinkedObjects() {
  showingLinkedObjects = [];
  showingAllLinkedObjects = [];
  return fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/loadTPandPP`).then(response => response.json()).then(data => {
    
    // Добавление на карту объектов в зависимости от их типа
    data.forEach(object => {
      
      if (object.typecode == 13) {
        showingAllLinkedObjects.push(object.name);
      }
    })
    
  })
  .catch(error => {
    console.error('Ошибка загрузки списка ПП/ТП:', error);
  });
}
export function ClearShowingAllLinkedObjects() {
  //showingAllLinkedObjects = [];
  showingAllLinkedObjects = showingAllLinkedObjects.filter(item => showingLinkedObjects.includes(item));
}

export function IsSchemaActive(linkedtp) {
  return showingLinkedObjects.includes(linkedtp);
}

export function ClearShowingLinkedObjects() {
  showingAllLinkedObjects = [];
}

export function SetLastLinkedObj(linkedObj) {
  lastLinkedObj = linkedObj;
}

export function GetLastLinkedObj() {
  return lastLinkedObj;
}

export function SetMovingPPid(linkedtp, isChecked) {
  if (isChecked) {
    movingPPArray.push(linkedtp);
  }
  else {
    var index = GetIndexMovingPParray(linkedtp)
    movingPPArray.splice(index, 1);
  }
}

export function GetIndexMovingPParray(linkedtp) {
  var index = -1;
    for (var i = 0; i < movingPPArray.length; i++) {
      if (movingPPArray[i] === linkedtp) {
        index = i;
        break;
      }
    }
  return index;
}

function SavePP(isEdit, id, latlng, polePopup, iMarker, linkedtp, oldNumber, button) {

  const encodedLinkedtp = encodeURIComponent(linkedtp);
  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/getPPbyName/${encodedLinkedtp}`)
  .then(response => response.json())
  .then(data => {
    if (data.length > 0 && oldNumber != data[0].name) {
      document.getElementById("errorText").textContent = "ПП с таким номером уже существует";
      button.disabled = false;
    } else {
      if (!isEdit) {
        AddPP(latlng, polePopup);
      }
      else {
        EditPP(id, latlng, polePopup, iMarker, oldNumber); 
      }
    }   
  })
  .catch(error => {
    console.error('Ошибка проверки номера ПП:', error);
    const errorText = document.getElementById("errorText");
    if (errorText) errorText.textContent = "Не удалось связаться с сервером. Попробуйте снова.";
    button.disabled = false;
  });
}

export function AddPPSetup(latlng, currentTime) {
    //Метод добавления кругов на карту
    
    document.getElementById(`PS-btn${currentTime}`).addEventListener('click', function() {


      if (isMobileVersion) {
        const container = document.createElement('div');
        document.body.appendChild(container);
        SetCurrentBottomSheet(container);

        const handleClose = () => {
          ReactDOM.unmountComponentAtNode(container);
          container.remove();
        };

        ReactDOM.render(
          <AddPSSheet
            title="Добавить ПС"
            onClose={handleClose}
            onSave={(number, textPosition) => {
              AddPSDirect(latlng, number, textPosition);
              handleClose();
            }}
          />,
          container
        );
        return;
      }

        var polePopupDiv = document.createElement('div');
		polePopupDiv.id = 'ppPopup';
        
		document.body.appendChild(polePopupDiv);

		document.getElementById('ppPopup').innerHTML = GetPPHtmlContent('');				

        var polePopup = L.popup()
        .setContent(polePopupDiv)
        .setLatLng(latlng)
        .openOn(map);
        polePopupDiv.parentElement.style.width = "350px";
        document.getElementById('savePP').addEventListener('click', function () {
            this.disabled = true;
            var linkedtp = document.getElementById('ppNumber').value;
            SavePP(false, null, latlng, polePopup, null, linkedtp, null, this);
            //AddPP(latlng, polePopup);     
        });
    });
}

function AddPSDirect(latlng, objectNumber, textPosition) {
  SetLastInsertedId(objectNumber);
  SetLastLinkedObj(objectNumber);

  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/insertObject`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ 
      name: objectNumber, 
      linkedtp: objectNumber, 
      typecode: 13, 
      lat: latlng.lat, 
      lng: latlng.lng, 
      textPosition,
      userId: GetUserId(),
      username: GetUserName()
    })
  })
  .then((response) => {
    if (!response.ok) {
      return response.json().then((errData) => {
        throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
      });
    }
    return response.json();
  })
  .then(response => {
    const objectId = response.id;

    var circle = DrawMainMarker(latlng, objectNumber, 13, textPosition, null, objectId, objectNumber).addTo(map);
    loadedMarkers.set(objectId, circle);
    SetLastInsertedMarker(circle);
    PPPopupSetup(circle, objectNumber, latlng.lat, latlng.lng, objectId);
    PopupBehavior(circle, objectId, latlng, objectNumber, 13, objectNumber);

    var ppObject = { id: objectId, name: objectNumber, children: [], lines: [] };
    linkedtpArray.push(ppObject);

    UnLoadAllPoles();
    UnLoadAllLines();
    document.getElementById('ShowAllObjects').checked = false;
  })
  .catch(error => {
    console.error('Ошибка добавления ПС:', error);
    alert(`Не удалось добавить ПС: ${error.message}`);
  });
}

function AddPP(latlng, popup) {

    var objectNumber = document.getElementById('ppNumber').value;
   // var linkedtp = objectNumber;
    var textPosition = parseInt(document.getElementById('textPosition').value);

    //lastLinkedObj = objectNumber;
    SetLastInsertedId(objectNumber);
    SetLastLinkedObj(objectNumber);

    var objectId;

    // Посылание информации на сервер методом POST
    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/insertObject`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          name: objectNumber, 
          linkedtp: objectNumber, 
          typecode: 13, 
          lat: latlng.lat, 
          lng: latlng.lng, 
          textPosition,
          userId: GetUserId(),        // ← добавить
          username: GetUserName()      // ← добавить
        })
        })
    .then((response) => {
        if (!response.ok) {
          return response.json().then((errData) => {
            throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
          });
        }
        return response.json().then(response => {

            objectId = response.id;
            //lastInsertedId = objectId;

            var circle = DrawMainMarker(latlng, objectNumber, 13, textPosition, null, objectId, objectNumber) .addTo(map);;
            loadedMarkers.set(objectId, circle);
            SetLastInsertedMarker(circle);
            PPPopupSetup(circle, objectNumber, latlng.lat, latlng.lng, objectId);

            PopupBehavior(circle, objectId, latlng, objectNumber, 13, objectNumber);

            var ppObject = {
                id: objectId,
                name: objectNumber,
                children: [],
                lines: []
              };

            linkedtpArray.push(ppObject);

            UnLoadAllPoles();
            UnLoadAllLines();
            document.getElementById("ShowAllObjects").checked = false;
          });
    })
    .catch(error => {
            console.error('Ошибка добавления ПС: ', error);
            alert(`Не удалось добавить ПС: ${error.message}`);
    });


    map.closePopup(popup);
}

function EditPPDirect(id, latlng, iMarker, objectNumber, linkedtp, textPosition, oldName) {
  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/updateObject`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: objectNumber, linkedtp: objectNumber, typecode: 13, textPosition, id,
      userId: GetUserId(), username: GetUserName()
    })
  })
  .then((response) => {
    if (!response.ok) {
      return response.json().then((errData) => {
        throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
      });
    }
    return response.json();
  })
  .then(response => {
    var circle = DrawMainMarker(latlng, objectNumber, 13, textPosition, iMarker, id, objectNumber).addTo(map);
    PPPopupSetup(circle, objectNumber, latlng.lat, latlng.lng, id);
    PopupBehavior(circle, id, latlng, objectNumber, 13, objectNumber);

    return fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/upd_all_linkedtp_by_name`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ newName: objectNumber, oldName })
    }).then(response => {
      var foundObject = linkedtpArray.find(o => o.name === oldName);
      if (foundObject) {
        foundObject.name = objectNumber;
        updatePolylineByFromId(id, objectNumber);
        updatePolylineByToId(id, objectNumber);
        foundObject.children.forEach(o => { o.circle.options.linkedtp = objectNumber; });
        foundObject.lines.forEach(o => { o.line.options.linkedtp = objectNumber; });
      }
    });
  })
  .catch(error => {
    console.error('Ошибка обновления ПС:', error);
    alert(`Не удалось сохранить ПС: ${error.message}`);
  });
}

export function EditPPSetup(id, latlng, iMarker) {
    //Метод добавления кругов на карту
    
    //fetch(`${process.env.REACT_APP_BASE_URL}/get_object_by_id/${id}`)
    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/get_object_by_id/${id}`)
    .then(response => response.json())
    .then(data => {
        data.forEach(obj => { 

            if (isMobileVersion) {
              // Мобильный — Bottom Sheet форма
              const container = document.createElement('div');
              document.body.appendChild(container);
              SetCurrentBottomSheet(container);

              const handleClose = () => {
                ReactDOM.unmountComponentAtNode(container);
                container.remove();
                ClearMarkerHighlight(iMarker); // редактирование закончено (сохранили или закрыли)
              };

              const handleSave = (objectNumber, textPosition) => {
                // Подменяем значения для существующей функции EditPP
                // Создаём временные элементы чтобы не менять логику EditPP
                EditPPDirect(id, latlng, iMarker, objectNumber, obj.linkedtp, textPosition, obj.name);
                handleClose();
              };

              const handleBack = () => {
                          ReactDOM.unmountComponentAtNode(container);
                          container.remove(); // ← убрать контейнер
              
                          // Симулируем клик на маркер чтобы снова открылся ObjectBottomSheet
                          if (iMarker) {
                            iMarker.fire('click');
                          }
                        };

              ReactDOM.render(
                <EditPPSheet
                  objectNumber={obj.name}
                  textPosition={obj.textPosition}
                  onClose={handleClose}
                  onSave={handleSave}
                  onBack={handleBack}
                />,
                container
              );
              return;
            }

            var polePopupDiv = document.createElement('div');
            polePopupDiv.id = 'ppPopup';
            
            //document.body.appendChild(polePopupDiv);

            /*document.getElementById('ppPopup')*/polePopupDiv.innerHTML = GetPPHtmlContent(obj.name);;				

            var polePopup = L.popup()
            .setContent(polePopupDiv)
            .setLatLng(latlng)
            .openOn(map);
            // openOn закрыл попап ПС (и снял выделение) — выделяем снова на время
            // редактирования; снимется при закрытии формы (в т.ч. после сохранения)
            if (iMarker) {
              HighlightMarker(iMarker);
              polePopup.on('remove', () => ClearMarkerHighlight(iMarker));
            }
            polePopupDiv.parentElement.style.width = "350px";

            document.getElementById("textPosition").value = obj.textPosition;

            document.getElementById('savePP').addEventListener('click', function () {
                this.disabled = true;
                var linkedtp = document.getElementById('ppNumber').value;
                //EditPP(id, latlng, polePopup, iMarker, obj.name);     
                SavePP(true, id, latlng, polePopup, iMarker, linkedtp, obj.name, this);
            });
        });
    })
    .catch(error => {
      ClearMarkerHighlight(iMarker);
      console.error('Ошибка загрузки данных ПС для редактирования:', error);
      alert('Не удалось загрузить данные объекта. Попробуйте снова.');
    });
}

function EditPP(id, latlng, popup, iMarker, oldName) {

    var objectNumber = document.getElementById('ppNumber').value;
    var linkedtp = objectNumber;
    var textPosition = parseInt(document.getElementById('textPosition').value);

    //lastLinkedObj = linkedtp;
    SetLastLinkedObj(objectNumber);

    // Посылание информации на сервер методом POST
    //fetch(`${process.env.REACT_APP_BASE_URL}/upd_object_by_id`, {
    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/updateObject`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: objectNumber,
          linkedtp: objectNumber,
          typecode: 13,
          textPosition,
          id,
          userId: GetUserId(),
          username: GetUserName()
        })
        })
    .then((response) => {
        if (!response.ok) {
          return response.json().then((errData) => {
            throw new Error(errData.error || `Ошибка сервера: ${response.status}`);
          });
        }

        var circle = DrawMainMarker(latlng, objectNumber, 13, textPosition, iMarker, id, objectNumber).addTo(map);
        PPPopupSetup(circle, objectNumber, latlng.lat, latlng.lng, id);
        PopupBehavior(circle, id, latlng, linkedtp, 13, objectNumber);

        // Посылание информации на сервер методом POST — только после успешного обновления самой ПС
        //fetch(`${process.env.REACT_APP_BASE_URL}/upd_all_linkedtp_by_name`, {
        return fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/upd_all_linkedtp_by_name`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({newName: objectNumber, oldName: oldName})
          })
      .then(response => {
         // Используем метод find() для поиска объекта по имени
         var foundObject = linkedtpArray.find(function(mainObject) {
          return mainObject.name === oldName;
        });

        updatePolylineByFromId(id, objectNumber);
        updatePolylineByToId(id, objectNumber);

        if (foundObject) {

          foundObject.name = linkedtp;

          foundObject.children.forEach(object => {
            object.circle.options.linkedtp = linkedtp;
            //object.circle.remove();
            //PolePopupSetup(object.circle, object.name, linkedtp, object.latlng.lat, object.latlng.lng, object.id);
            //PopupBehavior(object.circle, object.id, object.latlng, linkedtp, object.typecode, object.name);
        });
        foundObject.lines.forEach(object => {
          //LinePopupSetup(object.line, object.start_name, object.end_name, linkedtp);
          object.line.options.linkedtp = linkedtp;
         // object.line.options.start_name = object.start_name;
         // object.line.options.end_name = object.end_name;
      });

        } else {
         // console.log('Объект с указанным именем не найден');
        }
      });
    })
    .catch(error => {
            console.error('Ошибка обновления ПС: ', error);
            alert(`Не удалось сохранить ПС: ${error.message}`);
    });

    map.closePopup(popup);
}

export function PPPopupSetup(circle, objectNumber, lat, lng, id) {

  var isEditable = false;
  var departmentAccessArray = GetUserPermissions();
    const entry = departmentAccessArray.find(entry => entry.startsWith(objectNumber.substring(0, 2) + "=") || entry.startsWith("00="));
    if (entry) {
      // Если строка найдена, получаем значение
      const value = entry.split("=")[1];
      switch (value) {
        case '1':
        case '2':
          isEditable = true;
          
          break;
        case '3':
          isEditable = false;
          break;
      }
    }
  
  var editButtons = `<button id="editObject${id}" class="simple_button">Редактировать</button><button id="deleteObject${id}" class="simple_button">Удалить</button><button id="addLine${id}" class="simple_button">Добавить линию</button>`;

  var moveLabel = `<div style="display: flex; align-items: center; gap: 6px; margin-top: 4px;">
  <input type="checkbox" id="IsMovingObj${id}" ${getIsMovingChecked(objectNumber)} style="margin: 0; width: 16px; height: 16px; cursor: pointer;"/>
  <label for="IsMovingObj${id}" style="margin: 0; cursor: pointer; font-size: 13px;">Включить перемещение объектов</label>
</div>`;
  if (/*GetUserName() === 'azhalpakov' || isMobileVersion ||*/ !isEditable) {
    editButtons = `<button id="editObject${id}" class="simple_button" style="display: none;">Редактировать</button><button id="deleteObject${id}" class="simple_button" style="display: none;">Удалить</button>
    <button id="addLine${id}" class="simple_button" style="display: none;">Добавить линию</button>`;
    moveLabel = `<input type="checkbox" id="IsMovingObj${id}" ${getIsMovingChecked(objectNumber)} style="display: none;"/><label for="IsMovingObj${id}" style="display: none;">Включить перемещение объектов</label>`;
  }

  circle.off('click'); 
  // Привяжите событие popupopen к маркеру
  circle.on('click', function () {
    
    
    //<button id="passport${id}">Паспорт</button>
    const latlng = circle.getLatLng(); 

    if (!isMobileVersion) {
      if (lastMyDiv) {
        lastMyDiv.remove();
      }
      var popupContent = `<b>${objectNumber}</b><br>${editButtons}
      
      <button id="showAll${id}" class="simple_button">Показать схему</button>
      <button id="hideAll${id}" class="simple_button">Скрыть схему</button>
      <button id="showFiders${id}" class="simple_button">Фидеры</button>
      <button id="passport${id}" class="simple_button">Паспорт</button>
      ${moveLabel}`;
        var myDiv = document.createElement('div');
        myDiv.innerHTML = popupContent;
      var popup = L.popup()
                  .setContent(myDiv)
                  .setLatLng(latlng)
                  .openOn(map); 
      SetLastOpenedPopup(popup);    
      //GetPowerPP(objectNumber, id);
      lastMyDiv = myDiv;
      // Выделяем после openOn: он закрывает предыдущий попап, и если это был попап
      // этой же ПС, его 'remove' снял бы только что поставленное выделение
      HighlightMarker(circle);
      popup.on('remove', () => ClearMarkerHighlight(circle));
      return;
    }

    HighlightMarker(circle);

    // Мобильный — Bottom Sheet
    const container = document.createElement('div');
    document.body.appendChild(container);
    SetCurrentBottomSheet(container);

    // При переходе к редактированию или добавлению линии шторка объекта закрывается,
    // но выделение оставляем — его снимет следующая форма (сохранение / закрытие)
    let keepHighlight = false;

    const handleClose = () => {
      ReactDOM.unmountComponentAtNode(container);
      container.remove();
      if (!keepHighlight) ClearMarkerHighlight(circle);
    };

    ReactDOM.render(
      <PPBottomSheet
        objectNumber={objectNumber}
        id={id}
        isEditable={isEditable}
        isMoving={GetIndexMovingPParray(objectNumber) > -1}
        onClose={handleClose}
        onEdit={() => { keepHighlight = true; EditPPSetup(id, latlng, circle); }}
        onDelete={() => DeleteObjectWithConfirm(id, circle)}
        onAddLine={() => {
          keepHighlight = true;
          const container = document.createElement('div');
          document.body.appendChild(container);
          SetCurrentBottomSheet(container);

          // Если начали рисовать кривую линию — выделение держим до конца рисования
          // (его снимет обработчик DRAWSTOP в Main.js)
          let curveStarted = false;

          const handleClose = () => {
            ReactDOM.unmountComponentAtNode(container);
            container.remove();
            if (!curveStarted) ClearMarkerHighlight(circle);
          };

          const handleAddLineBack = () => {
                          ReactDOM.unmountComponentAtNode(container);
                          container.remove();
                          circle.fire('click'); // ← открываем ObjectBottomSheet заново
                        };

          const searchLink = `${process.env.REACT_APP_BASE_URL}/api/objects_list/getAllPolesByName?linkedtp=${objectNumber}&name=`;
          console.log('searchLink:', searchLink);
          const markerLatlng = circle.getLatLng();

          const handleAddLine = (selectedObject, typecode) => {
            if (typecode === '7c') {
              // Кривая линия
              var meta = {
                from_id: id,
                to_id: selectedObject.id,
                typecode: '7',
                linkedtp: objectNumber,
                start_name: objectNumber,
                end_name: selectedObject.name,
                end_lat: selectedObject.lat,   // ← добавить
                end_lng: selectedObject.lng
              };
              // startLineFromPoint недоступна напрямую — нужно экспортировать из Main.js
              curveStarted = true;
              StartCurveLine(markerLatlng, meta, circle);
            } else {
              AddLine(
                id,
                selectedObject.id,
                typecode,
                markerLatlng.lat,
                markerLatlng.lng,
                selectedObject.lat,
                selectedObject.lng,
                objectNumber,
                objectNumber,
                selectedObject.name
              );
            }
          };

          ReactDOM.render(
            <AddLineSheet
              onClose={handleClose}
              onAddLine={handleAddLine}
              searchLink={searchLink}
              onBack={handleAddLineBack}
            />,
            container
          );
        }}
        isSchemaActive={IsSchemaActive(objectNumber)}
        onToggleSchema={() => {
          if (IsSchemaActive(objectNumber)) {
            HideAllPoles(objectNumber);
          } else {
            ShowAllPoles(objectNumber, GetSelectedVoltageCodes());
          }
        }}
        onShowFiders={() => ShowFidersList(objectNumber, id)}
        onPassport={() => OpenSideBar(true)}
        onMovingChange={(e) => {
          SetMovingPPid(objectNumber, e.target.checked);
          SetDraggable(e.target.checked, objectNumber);
        }}
      />,
      container
    );
  });  
}

export function ShowFidersList(linkedtp, ppId) {
  const encodedLinkedtp = encodeURIComponent(linkedtp);
  
  fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/getFidersByLinkedtp/${encodedLinkedtp}`)
    .then(response => response.json())
    .then(fiders => {

      if (isMobileVersion) {
        const container = document.createElement('div');
        document.body.appendChild(container);
        SetCurrentBottomSheet(container);

        const handleClose = () => {
          ReactDOM.unmountComponentAtNode(container);
          container.remove();
        };

        const ppMarker = loadedMarkers.get(ppId);

        const handleBack = () => {
                          ReactDOM.unmountComponentAtNode(container);
                          container.remove();
                          if (ppMarker) {
                            ppMarker.fire('click'); // ← открываем ObjectBottomSheet заново
                          }
                        };

        ReactDOM.render(
          <FidersSheet
            linkedtp={linkedtp}
            fiders={fiders}
            onClose={handleClose}
            onSelect={(lineId) => ShowFiderOnMap(lineId)}
            onBack={handleBack}
          />,
          container
        );
        return;
      }

      if (fiders.length === 0) {
        alert('Фидеры не найдены');
        return;
      }

      // Создаём popup со списком фидеров
      const marker = linkedtpArray.find(o => o.name === linkedtp);
      const latlng = map.getCenter(); // или координаты маркера ПП

      var myDiv = document.createElement('div');
      myDiv.style.maxHeight = '200px';
      myDiv.style.overflowY = 'auto';
      myDiv.style.minWidth = '200px';

      var buttons = fiders.map(f => 
        `<button id="fider-btn-${f.line_id}" class="simple_button" style="display: block; width: 90%; margin-bottom: 4px;">${f.fider_name}</button>`
      ).join('');

      myDiv.innerHTML = `<b>Фидеры ${linkedtp}:</b><br>${buttons}`;

      var popup = L.popup({ maxWidth: 200 })
        .setContent(myDiv)
        .setLatLng(latlng)
        .openOn(map);

      // Вешаем обработчики на каждую кнопку фидера
      fiders.forEach(fider => {
        document.getElementById(`fider-btn-${fider.line_id}`)
          .addEventListener('click', function () {
            map.closePopup(popup);
            ShowFiderOnMap(fider.line_id);
          });
      });
    })
    .catch(error => console.error('Ошибка загрузки фидеров:', error));
}

export function ClearActiveFider() {
  console.log('ClearActiveFider');
  activeFiderLineId = null;
  fiderBoundsSet = false; 
}

export function GetActiveFiderLineId() { return activeFiderLineId; }
export function SetActiveFiderLineId(lineid) { activeFiderLineId = lineid; }

export function ShowFiderOnMap(lineId, resetBounds = true) {
  if (resetBounds) {
    fiderBoundsSet = false; // ← сбрасываем только когда пользователь сам выбрал фидер
  }
  activeFiderLineId = lineId;
  // Очищаем текущую схему
  UnLoadAllPoles();
  UnLoadAllLines();
  ClearShowingLinkedObjects();
  ClearShowingAllLinkedObjects();

  // Загружаем объекты фидера
  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/load_fider_by_line_id/${lineId}`)
    .then(response => response.json())
    .then(data => {
      data.forEach(object => {
        const latlng = L.latLng(object.lat, object.lng);
        var circle = DrawPoleMarker(latlng, object.typecode.toString(), /*object.countPlafond*/null, 
          object.name, 1, 2, object.textPosition, null, object.id, object.linkedtp).addTo(map);
        PolePopupSetup(circle, object.name, object.linkedtp, object.lat, object.lng, object.id);
        PopupBehavior(circle, object.id, latlng, object.linkedtp, object.typecode, object.name);

        var foundObject = linkedtpArray.find(o => o.name === object.linkedtp);
        if (foundObject) {
          foundObject.children.push({ id: object.id, name: object.name, circle, typecode: object.typecode, latlng });
        }
      });
    })
    .catch(error => {
      console.error('Ошибка загрузки опор фидера:', error);
    });

  // Загружаем линии фидера
  fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/load_fider_lines_by_line_id/${lineId}`)
    .then(response => response.json())
    .then(data => {
      const allLatLngs = [];

      data.forEach(line => {
        const { id, from_id, to_id, linkedtp, typecode, start_name, end_name, voltage_class, geojson } = line;
        
        const geo = JSON.parse(geojson);
        const latlngs = geo.coordinates.map(c => [c[1], c[0]]);

        allLatLngs.push(...latlngs);

        let line_color = 'black';
        switch (voltage_class) {
          case 128: line_color = 'orange'; break;
          case 129: line_color = 'yellow'; break;
          case 130: line_color = 'red'; break;
          case 131: line_color = 'green'; break;
          case 133: line_color = 'purple'; break;
          case 134: line_color = 'blue'; break;
        }

        const lineStyle = {
          color: line_color,
          id, from_id, to_id, linkedtp, start_name, end_name,
          ...(typecode == 7 && { dashArray: '7, 7' })
        };

        const polyline = L.polyline(latlngs, lineStyle).addTo(map);
        linesData.polylineArray.push(polyline);

        var foundObject = linkedtpArray.find(o => o.name === linkedtp);
        if (foundObject) {
          foundObject.lines.push({ id, line: polyline, start_name, end_name, from_id, to_id });
        }

        LinePopupSetup(polyline, start_name, end_name, linkedtp, typecode);

        if (allLatLngs.length > 0 && !fiderBoundsSet) {
          const bounds = L.latLngBounds(allLatLngs);
          map.fitBounds(bounds, { padding: [50, 50] });
          fiderBoundsSet = true; // ← больше не перемещаем
        }
      });
    })
    .catch(error => {
      console.error('Ошибка загрузки линий фидера:', error);
    });
}

function getIsMovingChecked(objectNumber) {
  var isChecked = '';
  if (GetIndexMovingPParray(objectNumber) > -1) {
    isChecked = 'checked';
    
  }
  return isChecked;
}

export function HideAllPoles(linkedtp) {

    ClearActiveFider();
    
    const index = showingLinkedObjects.indexOf(linkedtp);
    if (index > -1) { // only splice array when item is found
      showingLinkedObjects.splice(index, 1); // 2nd parameter means remove one item only
    }

    const index2 = showingAllLinkedObjects.indexOf(linkedtp);
    if (index2 > -1) { // only splice array when item is found
      showingAllLinkedObjects.splice(index2, 1); // 2nd parameter means remove one item only
    }
  
    var foundObject = linkedtpArray.find(function(mainObject) {
        return mainObject.name === linkedtp;
      });
      
      if (foundObject) {
       
        foundObject.children.forEach(object => { 

            /*const index = markersArray.indexOf(object.circle);
            if (index > -1) { // only splice array when item is found
                markersArray.splice(index, 1); // 2nd parameter means remove one item only
            }*/
            object.circle.remove();
        });
        foundObject.children = [];
        foundObject.lines.forEach(object => { 
            object.line.remove();

            var polylineIndex = -1;
            for (var i = 0; i < linesData.polylineArray.length; i++) {
                if (linesData.polylineArray[i].options.id === object.id) {
                    polylineIndex = i;
                break;
               }
            }
    
            // Если полилиния найдена, удалите её из массива
            if (polylineIndex !== -1) {
                var removedPolyline = linesData.polylineArray.splice(polylineIndex, 1);
                
            } else {
              //  console.log('Полилиния с указанным id не найдена');
            }

        });
        foundObject.lines = [];
      } else {
        //console.log('Объект с указанным именем не найден');
      }
}

export async function ShowAllVisiblePoles(depName, selectedVoltageCodes) {

  const voltageParam = selectedVoltageCodes.length 
  ? selectedVoltageCodes.join(',') 
  : '';

  var bounds = map.getBounds();
  var northEast = bounds.getNorthEast();
  var southWest = bounds.getSouthWest();
  if (showingAllLinkedObjects.length > 0) {
    const encodedDepName = encodeURIComponent(depName);

  fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/load_visible_poles_by?depName=${encodedDepName}&neLat=${northEast.lat}&neLng=${northEast.lng}&swLat=${southWest.lat}&swLng=${southWest.lng}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({linkedtp: showingAllLinkedObjects})
    })
  .then(response => response.json())
  .then(data => {
    ClearPoleMarkersArray();
      data.forEach(object => { 

          const latlng = L.latLng(object.lat, object.lng);
         // const circle = DrawPoleMarker([object.lat, object.lng], object.typecode.toString(), object.countPlafond, object.name, 1, 2, object.textPosition, null, object.id, object.linkedtp).addTo(map);
          var circle;
          if (object.typecode == 10 || object.typecode == 12) {
            circle = DrawDecorativeMarker(latlng, object.typecode, object.id, object.linkedtp, null).addTo(map);
            DecorativePopupSetup(object.typecode, circle, object.id, latlng, object.parentname, object.linkedtp);
          }
          else {
            circle = DrawPoleMarker(latlng, object.typecode.toString(), /*object.countPlafond*/null, object.name, 1, 2, object.textPosition, null, object.id, object.linkedtp).addTo(map);
            PolePopupSetup(circle, object.name, object.linkedtp, object.lat, object.lng, object.id);
          }

          //PolePopupSetup(circle, object.name, object.linkedtp, object.lat, object.lng, object.id);
          PopupBehavior(circle, object.id, latlng, object.linkedtp, object.typecode, object.name);

          var childObject1_1 = {
              id: object.id,
              name: object.name,
              circle: circle,
              typecode: object.typecode,
              latlng: latlng
            };

            // Используем метод find() для поиска объекта по имени
            var foundObject = linkedtpArray.find(function(mainObject) {
              return mainObject.name === object.linkedtp;
            });
            
            if (foundObject) {
    // ← найти существующий объект и обновить ссылку на маркер
    const existing = foundObject.children.find(c => c.id === object.id);
    if (existing) {
      existing.circle = circle; // ← обновить ссылку на новый маркер
    } else {
      foundObject.children.push(childObject1_1);
    }
  } else {
              
              var ppObject = {
                    id: 0,
                    name: object.linkedtp,
                    children: [],
                    lines: []
                  };
                foundObject = ppObject;
                linkedtpArray.push(ppObject);
                foundObject.children.push(childObject1_1);
            }

          
      });
  })
  .catch(error => {
    console.error('Ошибка загрузки видимых опор:', error);
  })

  fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/load_visible_lines_by?depName=${encodedDepName}&neLat=${northEast.lat}&neLng=${northEast.lng}&swLat=${southWest.lat}&swLng=${southWest.lng}` +
  (voltageParam ? `&voltageClasses=${voltageParam}` : ''), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({linkedtp: showingAllLinkedObjects})
    })
    .then(response => response.json())
    .then(data => {
      UnLoadAllLines();
        data.forEach(line => { 

            const {id, from_id, to_id, linkedtp, start_lat, start_lng, end_lat, end_lng, typecode, start_name, end_name, voltage_class, geojson } = line;

              const geo = JSON.parse(geojson);
const latlngs = geo.coordinates.map(c => [c[1], c[0]]);

            var line_color = 'black';

              switch (voltage_class) {
                case 128:
                  line_color = 'orange';
                  break;
                case 129:
                  line_color = 'yellow';
                  break;
                case 130:
                  line_color = 'red';
                  break;
                case 131:
                  line_color = 'green';
                  break;
                case 133:
                  line_color = 'purple';
                  break;
                 case 134:
                  line_color = 'blue';
                  break;
                default:
                  line_color = 'black';
                  break;
              }

              // Изменение стиля линии в зависимости от типа линии в переменной type
              const lineStyle = typecode == 7 ? { dashArray: '7, 7', color: line_color, id: id, from_id: from_id, to_id: to_id, linkedtp: linkedtp, start_name: start_name, end_name: end_name  } 
                : { color: line_color, id: id, from_id: from_id, to_id: to_id, linkedtp: linkedtp, start_name: start_name, end_name: end_name };

              const polyline = L.polyline(latlngs, lineStyle).addTo(map);
			  linesData.polylineArray.push(polyline);	
              
              
              var childObject1_1 = {
                id: line.id,
                line: polyline,
                start_name: line.start_name,
                end_name: line.end_name,
                from_id: from_id,
                to_id: to_id
              };

              // Используем метод find() для поиска объекта по имени
              var foundObject = linkedtpArray.find(function(mainObject) {
                return mainObject.name === linkedtp;
              });
              
              if (foundObject) {
                
                if (foundObject && !foundObject.lines.find(l => l.id === childObject1_1.id)) {
                  foundObject.lines.push(childObject1_1);
                }
              } else {
                
                var ppObject = {
                    id: 0,
                    name: line.linkedtp,
                    children: [],
                    lines: []
                  };
                foundObject = ppObject;
                linkedtpArray.push(ppObject);
                foundObject.lines.push(childObject1_1);
              }

              LinePopupSetup(polyline, start_name, end_name, linkedtp, typecode);
        });
    })
    .catch(error => {
      console.error('Ошибка загрузки видимых линий:', error);
    })
  }
}

export function ShowAllPoles(linkedtp, selectedVoltageCodes) {

    const voltageParam = selectedVoltageCodes.length 
  ? selectedVoltageCodes.join(',') 
  : '';

    HideAllPoles(linkedtp);
    showingLinkedObjects.push(linkedtp);
    showingAllLinkedObjects.push(linkedtp);
    //Метод добавления кругов на карту
    //fetch(`${process.env.REACT_APP_BASE_URL}/load_poles_by/${linkedtp}`)
    const encodedLinkedtp = encodeURIComponent(linkedtp);

    fetch(`${process.env.REACT_APP_BASE_URL}/api/objects_list/load_poles_by/${encodedLinkedtp}`)
    .then(response => response.json())
    .then(data => {
        data.forEach(object => { 

            const latlng = L.latLng(object.lat, object.lng);
            var circle;
            if (object.typecode == 10 || object.typecode == 12) {
              circle = DrawDecorativeMarker(latlng, object.typecode, object.id, object.linkedtp, null).addTo(map);
              DecorativePopupSetup(object.typecode, circle, object.id, latlng, object.parentname, object.linkedtp);
            }
            else {
              circle = DrawPoleMarker(latlng, object.typecode.toString(), /*object.countPlafond*/"", object.name, 1, 2, object.textPosition, null, object.id, linkedtp).addTo(map);
              PolePopupSetup(circle, object.name, object.linkedtp, object.lat, object.lng, object.id);
            }
            PopupBehavior(circle, object.id, latlng, object.linkedtp, object.typecode, object.name);

            var childObject1_1 = {
                id: object.id,
                name: object.name,
                circle: circle,
                typecode: object.typecode,
                latlng: latlng
              };

              // Используем метод find() для поиска объекта по имени
              var foundObject = linkedtpArray.find(function(mainObject) {
                return mainObject.name === linkedtp;
              });
              
              if (foundObject) {
                
                foundObject.children.push(childObject1_1);
              } else {
              // console.log('Объект с указанным именем не найден');
              }

            
        });
    
    })

    //fetch(`${process.env.REACT_APP_BASE_URL}/load_lines_by/${linkedtp}`)
    fetch(`${process.env.REACT_APP_BASE_URL}/api/lines_list/load_lines_by/${encodedLinkedtp}`  +
  (voltageParam ? `?voltageClasses=${voltageParam}` : ''))
    .then(response => response.json())
    .then(data => {
        data.forEach(line => { 

            const {id, from_id, to_id, linkedtp, start_lat, start_lng, end_lat, end_lng, typecode, start_name, end_name, voltage_class, geojson } = line;

              // приствоение точек начала и конца линии
             /* const startPoint = L.latLng(start_lat, start_lng);
              const endPoint = L.latLng(end_lat, end_lng);*/

            const geo = JSON.parse(geojson);
          const latlngs = geo.coordinates.map(c => [c[1], c[0]]);

              var line_color = 'black';
         
              switch (voltage_class) {
                case 128:
                  line_color = 'orange';
                  break;
                case 129:
                  line_color = 'yellow';
                  break;
                case 130:
                  line_color = 'red';
                  break;
                case 131:
                  line_color = 'green';
                  break;
                case 133:
                  line_color = 'purple';
                  break;
                 case 134:
                  line_color = 'blue';
                  break;
                default:
                  line_color = 'black';
                  break;
              }

              // Изменение стиля линии в зависимости от типа линии в переменной type
              const lineStyle = typecode == 7 ? { dashArray: '7, 7', color: line_color, id: id, from_id: from_id, to_id: to_id, linkedtp: linkedtp, start_name: start_name, end_name: end_name } 
              : { color: line_color, id: id, from_id: from_id, to_id: to_id, linkedtp: linkedtp, start_name: start_name, end_name: end_name };

              // Создание Polyline между startPoint и endPoint со стилем type
              //const polyline = L.polyline([startPoint, endPoint], lineStyle).addTo(map);
              const polyline = L.polyline(latlngs, lineStyle).addTo(map);
			  linesData.polylineArray.push(polyline);	
              
              
              var childObject1_1 = {
                id: line.id,
                line: polyline,
                start_name: line.start_name,
                end_name: line.end_name,
                from_id: from_id,
                to_id: to_id
              };

              // Используем метод find() для поиска объекта по имени
              var foundObject = linkedtpArray.find(function(mainObject) {
                return mainObject.name === linkedtp;
              });
              
              if (foundObject) {
               
                foundObject.lines.push(childObject1_1);
              } else {
                //console.log('Объект с указанным именем не найден');
              }

              // Создание popup с информацией о линии и возможностью ее удаления
             /* const popupContent = `Линия : ${from_id} - ${to_id}<br>номер ШУНО линии: ${linkedtp}<br><button id="deleteLine">Удалить Линию</button>`;
              polyline.bindPopup(popupContent);*/
              LinePopupSetup(polyline, start_name, end_name, linkedtp, typecode);
            //  LinePopupBehavior(polyline, line.id, line.typecode);
        });
    })
}

export function ShowPassport(id, latlng, iMarker)  {

  fetch(`${process.env.REACT_APP_BASE_URL}/api/object_params/getParams/${id}`)
  //fetch(`${process.env.REACT_APP_BASE_URL}/getPassport`)
    .then(response => response.json())
    .then(data => {

      const table = document.createElement("table");
      table.classList.add("my-table");

      // Создаем заголовок таблицы
      const headerRow = document.createElement("tr");
      const idHeader = document.createElement("th");
      idHeader.textContent = "№";
      const paramnameHeader = document.createElement("th");
      paramnameHeader.textContent = "Позиция";
      const paramvalueHeader = document.createElement("th");
      paramvalueHeader.textContent = "Данные";

      headerRow.appendChild(idHeader);
      headerRow.appendChild(paramnameHeader);
      headerRow.appendChild(paramvalueHeader);
      table.appendChild(headerRow);

      let counter = 1;
      let lastCat = 0;
        data.forEach(obj => { 
          
          if (lastCat != obj.category_id) {
            const titleHeaderRow = document.createElement("tr");
            const titleHeader = document.createElement("th");
            titleHeader.style = "text-align: center;";
            titleHeader.textContent = obj.catname;
            titleHeader.colSpan = 3;
    
            titleHeaderRow.appendChild(titleHeader);
            table.appendChild(titleHeaderRow);
            counter = 1;
          }
          else {
            counter++;
          }
          lastCat = obj.category_id;

          const row = document.createElement("tr");
          const idCell = document.createElement("td");
          idCell.textContent = counter;
          const paramnameCell = document.createElement("td");
          paramnameCell.textContent = obj.paramname;
          const paramvalueCell = document.createElement("td");
          paramvalueCell.textContent = obj.paramvalue;

          row.appendChild(idCell);
          row.appendChild(paramnameCell);
          row.appendChild(paramvalueCell);
          table.appendChild(row);

          

            var polePopupDiv = document.createElement('div');
            polePopupDiv.id = 'ppPopup' + obj.id;
            polePopupDiv.style = "overflow: auto; max-height: 800px;";
            
            document.body.appendChild(polePopupDiv);

            polePopupDiv.appendChild(table);

            //document.getElementById('ppPopup' + obj.id).innerHTML = table;				

            var polePopup = L.popup()
            .setContent(polePopupDiv)
            .setLatLng(latlng)
            .openOn(map);
            polePopupDiv.parentElement.style.width = "550px";

        });
    })

}

function GetPPHtmlContent(objectName) {
    var tpNumberContent = '<label for="ppNumber">Номер ПС: </label><input type="text" id="ppNumber" name="ppNumber" value="' + objectName + '">';
    var textPosition = '<br><label for="cars">Расположение номера: </label>' +
        '<select name="textPosition" id="textPosition">' +
        '<option value="0">Сверху</option>' +
        '<option value="1">Справа</option>' +
        '<option value="2">Снизу</option>' +
        '<option value="3">Слева</option>' +
        '</select><br>'
    var submitContent = '<br><button id="savePP" class="simple_button">Сохранить</button><span class="error-text" id="errorText"></span>';    

    var htmlContent = tpNumberContent  + textPosition + submitContent;
    return htmlContent;
}